import { ToggleSelect } from "../../../landingPage/pages/Homepage/components/ToggleSelect";
import React, { useMemo } from "react";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import useIsScreenXXS from "../../../landingPage/hooks/useIsScreenXXS";
import withTranslations from "../../../../../hocs/withTranslations";
import { getPeriodToggleOptions } from "../../../../../lib/Plans";

const PlansToggleSelection = ({
  hasGuaranteedUserOffer,
  period,
  allowedPeriods,
  allowPeriodChange,
  handleSetPeriod,
  translate
}) => {
  const isDesktop = useIsDesktop();
  const isScreenXXS = useIsScreenXXS();

  const options = useMemo(() => {
    const tooltipContent = `<span class="text-xs text-white">${translate(
      "plans_toggle-select_yearly_tooltip_1"
    )}<strong class="text-bold text-yellow ml-1">${translate(
      "plans_toggle-select_yearly_tooltip_2"
    )}</strong></span>`;

    const yearlyTooltip = hasGuaranteedUserOffer
      ? undefined
      : {
          tooltipBottom: isDesktop || isScreenXXS ? tooltipContent : null,
          tooltipRight: !isDesktop && !isScreenXXS ? tooltipContent : null
        };

    return getPeriodToggleOptions({
      allowedPeriods,
      translate,
      yearlyTooltip
    });
  }, [
    allowedPeriods,
    hasGuaranteedUserOffer,
    isDesktop,
    isScreenXXS,
    translate
  ]);

  return (
    <ToggleSelect
      options={options}
      value={period}
      disabled={!allowPeriodChange}
      tooltip={
        !allowPeriodChange
          ? translate("plans_toggle-disabled-period-change-tooltip")
          : undefined
      }
      onChange={handleSetPeriod}
    />
  );
};

export default withTranslations(PlansToggleSelection);
